import { EuiBasicTable, EuiButtonIcon, EuiSpacer } from "@elastic/eui";
import React from "react";

import { useDeleteShopGroupMutation, useShopGroupsQuery } from "../../api/react-query/queries/admin-page";
import ConfirmationDialog from "../../components/modals/ConfirmationDialog";
import { Shop } from "../../utils/types";

//TODO Viggo Make actions a separate component similar to the one in the KindsList

const ShopGroupList = () => {
    const { shopGroups } = useShopGroupsQuery();
    const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);
    const [deleteItem, setDeleteItem] = React.useState("");
    const { mutate: deleteShopGroup } = useDeleteShopGroupMutation();

    const handleDelete = (id: string) => {
        setDeleteItem(id);
        setConfirmDialogOpen(true);
    };

    const columns = [
        {
            field: "name",
            name: "Name",
            sortable: true,
            width: "300px",
        },
        {
            field: "shops",
            name: "Shops",
            sortable: true,
            render: (shops: Shop[]) => {
                return shops.map((shop) => shop.name).join(", ");
            },
        },
        {
            width: "100px",
            name: "Actions",
            field: "id",
            render: (id: string) => {
                return (
                    <div>
                        <EuiButtonIcon iconType="pencil" />
                        <EuiSpacer size="m" />
                        <EuiButtonIcon onClick={() => handleDelete(id)} color="danger" iconType="trash" />
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <EuiBasicTable items={shopGroups} columns={columns} itemId="id" />
            <ConfirmationDialog
                isOpen={confirmDialogOpen}
                cancel={() => setConfirmDialogOpen(false)}
                confirm={() => {
                    deleteShopGroup(deleteItem);
                    setConfirmDialogOpen(false);
                }}
                question={"Weet je zeker dat je deze wilt wissen?"}
            />
        </>
    );
};

export default ShopGroupList;
